import React, { useState } from 'react';
import { TextField, DateField, ReferenceArrayInput, FunctionField } from 'react-admin';
import { Button, makeStyles } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import { Dialog } from 'components/common';
import { Datagrid, List, Filter } from 'components/list';
import ChipsArrayInput from 'components/inputs/ChipsArrayInput';

const useStyles = makeStyles((theme) => ({
  contextButton: {
    minWidth: 0,
    padding: 0,
    textTransform: 'none',
    textDecoration: 'underline',
    fontWeight: 400,
  },
  contextContent: {
    margin: 0,
    maxHeight: theme.spacing(50),
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontFamily: 'monospace',
  },
}));

const ActivityFilters = (props) => (
  <Filter {...props}>
    <ReferenceArrayInput
      icon={CheckCircleOutlineIcon}
      basePath={props.basePath}
      label="Activity type"
      source="actions"
      reference="userActivityTypes"
      allowEmpty>
      <ChipsArrayInput optionValue="code" optionLabel="name" />
    </ReferenceArrayInput>
  </Filter>
);

const formatContext = (context) => {
  try {
    const formattedContext = JSON.stringify(context, null, 2);

    return formattedContext === undefined ? 'No context data' : formattedContext;
  } catch (error) {
    return String(context);
  }
};

const ActivityTab = (props) => {
  const classes = useStyles();

  const [contextDialogOpen, setContextDialogOpen] = useState<boolean>(false);
  const [selectedContext, setSelectedContext] = useState<any>(null);

  const handleOpenContext = (context) => {
    setSelectedContext(context);
    setContextDialogOpen(true);
  };

  const handleCloseContext = () => {
    setContextDialogOpen(false);
  };

  return (
    <>
      <List
        {...props}
        resource="userActivity"
        basePath="/users"
        filter={{ tenant: props.id }}
        filters={<ActivityFilters />}>
        <Datagrid>
          <TextField source="description" label="Action" sortable={false} />
          <TextField source="adminUsername" label="Admin" sortable={false} />
          <TextField source="userIpAddress" label="IP Address" sortable={false} />
          <DateField
            source="createdAt"
            label="Date"
            options={{
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            }}
            sortable={false}
          />
          <FunctionField
            label="Context"
            sortable={false}
            render={(record) => {
              const context = record?.context;
              const hasContext = context !== null && context !== undefined && context !== '';

              if (!hasContext) {
                return '---';
              }

              return (
                <Button
                  color="primary"
                  variant="text"
                  className={classes.contextButton}
                  onClick={() => handleOpenContext(context)}>
                  Show context
                </Button>
              );
            }}
          />
        </Datagrid>
      </List>

      {contextDialogOpen && (
        <Dialog
          open={contextDialogOpen}
          onCancel={handleCloseContext}
          title="Context"
          cancelText="Close">
          <pre className={classes.contextContent}>{formatContext(selectedContext)}</pre>
        </Dialog>
      )}
    </>
  );
};

export default ActivityTab;
